export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Entrar",
    "login.form.hint.user": "Logon",
    "login.form.hint.password": "Senha",
    "login.form.checkbox.remember-me": "Lembrar de mim",
    "login.form.button.sign-in": "Entrar",
    "login.form.message.invalid-user-credentials": "Logon ou senha está incorreto",
    "login.form.message.user-required": "Digite um logon",
    "login.form.message.password-required": "Digite uma senha",
    "login.form.button.forgot-password": "Esqueceu sua senha?",
    "error.root-admin-login.title": "Erro 403 – proibido",
    "error.root-admin-login.message": "Você está conectado como Administrador somente leitura. Para acessar o console do Web Recovery, entre como usuário de locatário do cliente ou administrador"
};
